import { render, staticRenderFns } from "./recommendType.vue?vue&type=template&id=048c8cb1&scoped=true"
import script from "./recommendType.vue?vue&type=script&lang=js"
export * from "./recommendType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c8cb1",
  null
  
)

export default component.exports